"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PrismyInPool = function PrismyInPool(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "prismy-in-pool",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M4.6.97L7.25 4.5l.04.07c.19.38.04.83-.33 1.01L4.34 6.9c-.22.1-.46.1-.68 0L1 5.56.93 5.5a.75.75 0 01-.15-1.05L3.4.96 3.47.9l.08-.07.1-.06c.32-.18.72-.1.95.2zm-.6.86l-2.24 3L4 5.93l2.24-1.12L4 1.83zm.5 1.42c.14 0 .25.11.25.25V4a.25.25 0 11-.5 0v-.5c0-.14.11-.25.25-.25zm-1 0c.14 0 .25.11.25.25V4a.25.25 0 11-.5 0v-.5c0-.14.11-.25.25-.25z"
  }), _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M.7 7.12l.77-.33a.5.5 0 01.4 0l.37.16c.38.16.8.16 1.18 0l.38-.16a.5.5 0 01.4 0l.38.16c.37.16.8.16 1.18 0l.38-.16a.5.5 0 01.39 0l.77.33a.5.5 0 00.4-.92l-.78-.33a1.5 1.5 0 00-1.18 0l-.38.16a.5.5 0 01-.39 0l-.38-.16a1.5 1.5 0 00-1.18 0l-.38.16a.5.5 0 01-.4 0l-.37-.16a1.5 1.5 0 00-1.18 0L.3 6.2a.5.5 0 10.4.92z",
    transform: "matrix(1 0 0 -1 0 12.91)"
  }));
};

PrismyInPool.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = PrismyInPool;
exports["default"] = _default;